module.exports = __webpack_public_path__ + "static/img/84.a85a9e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/84.png
// module id = Lc21
// module chunks = 1